const layer = 'dataLayer';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default defineNuxtPlugin({
  name: 'gtm',
  async setup(nuxtApp) {
    const { $domain, $config } = useNuxtApp();

    nuxtApp.provide('gtm', {
      push(obj: any) {
        if (!$config.public.gtm?.enabled) {
          return;
        }

        if ($config.public.gtm?.debug) {
          console.log('push', obj);
        }

        if (!window[layer]) {
          window[layer] = [];
        }

        if (obj.event !== 'trusted_shops_data') {
          window[layer].push({ ecommerce: null });
        }

        window[layer].push(obj);
      },
    });

    if (!$domain?.gtmId) {
      throw new Error('Missing GTM config');
    }

    useHead({
      script: [{
        'src': `https://www.googletagmanager.com/gtm.js?id=${$domain.gtmId}`,
        'data-usercentrics': 'Google Tag Manager',
        'type': 'text/plain',
        'defer': true,
        'async': true,
      }],
    });

    // GTM Server
    const url = new URL($domain.gtmServer.url);
    url.searchParams.append('id', $domain.gtmServer.id);

    window[layer] = window[layer] || [];
    window[layer].push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' });
    useHead({
      script: [{
        'src': url.toString(),
        'data-usercentrics': 'Google Tag Manager',
        'type': 'text/plain',
        'defer': true,
        'async': true,
      }],
    });
  },
});
